import { render, staticRenderFns } from "./HandiList.vue?vue&type=template&id=1cbcbb80&"
import script from "./HandiList.vue?vue&type=script&lang=js&"
export * from "./HandiList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports